export const TabValue = {
  VIEW: 'view',
  SYSTEM: 'system',
  PLAN_SCHEDULING: 'planScheduling',
  CUSTOM_FIELDS: 'customFields',
  DEPENDENCIES: 'dependencies',
  SYNC_FAILURES: 'syncFailures',
  FINANCIALS: 'financials',
} as const;

export const PanelTabValue = {
  HEALTH_RISK: 'healthRisk',
  MISSING_DATA: 'missingData',
  DEPENDENCY: 'dependency',
} as const;

export type TabValueType = (typeof TabValue)[keyof typeof TabValue];
export type PanelTabValueType = (typeof PanelTabValue)[keyof typeof PanelTabValue];
